import { ReactNode } from 'react';

export type CalloutSeverity = 'info' | 'warning' | 'high';

interface CalloutProps {
  severity: CalloutSeverity;
  heading: ReactNode;
  children: ReactNode;
  className?: string;
}

const STYLES: Record<CalloutSeverity, { wrapper: string; heading: string }> = {
  info: {
    wrapper: 'border-l-4 border-slate-500 bg-slate-50',
    heading: 'text-slate-700',
  },
  warning: {
    wrapper: 'border-l-4 border-amber-600 bg-amber-50',
    heading: 'text-amber-900',
  },
  high: {
    wrapper: 'border-l-4 border-red-700 bg-red-50',
    heading: 'text-red-800',
  },
};

/**
 * Severity-coloured callout — mirrors the PDF generator's `drawCallout`.
 * Used for "What this means" explanations and risk-flag bucket containers
 * on Page 1.
 */
export function Callout({ severity, heading, children, className = '' }: CalloutProps) {
  const styles = STYLES[severity];
  return (
    <div className={`${styles.wrapper} rounded-r-sm p-4 ${className}`}>
      <h4 className={`text-sm font-semibold ${styles.heading} mb-2`}>{heading}</h4>
      <div className="text-sm text-slate-800 space-y-1">{children}</div>
    </div>
  );
}
